import styled from 'styled-components'
import Card, { CardImage } from './Card'
import Container from './layout/Container'
import Stack from './layout/Stack'
import Image from './Image'

function CourseSessions( { sessions } ) {
  return (
    <Stack $bottom={ 6 }>
      <Container>
        <StyledGrid>
          { sessions.map( ( session, i ) => (
            <Card
              key={ session.id }
              href={ `/course/${ session.slug }` }
            >
              <p>Session { intToWords( i ) }</p>
              <h3>{ session.title }</h3>
              <CardImage>
                <Image
                  src={ session.sessionIcon[ 0 ].url }
                  alt={ session.sessionIcon[ 0 ].alt }
                  width={ session.sessionIcon[ 0 ].width }
                  height={ session.sessionIcon[ 0 ].height }
                  dateModified={ session.sessionIcon[ 0 ].dateModified }
                  layout="fill"
                  objectFit="contain"
                  sizes="150px"
                />
              </CardImage>
            </Card>
          ) ) }
        </StyledGrid>
      </Container>
    </Stack>
  )
}

function intToWords( int ) {
  const ones = [
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fouteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
    'twenty',
  ]

  return ones[ int ] || `${ int }`
}

const StyledGrid = styled.div`
  display: grid;
  margin: calc( var( --grid-gutter ) / -2 );

  > * {
    margin: calc( var( --grid-gutter ) / 2 );
  }

  @media ( min-width: 650px ) {
    grid-template-columns: repeat( 3, 1fr );
  }
`

export default CourseSessions
